import { useEffect, useState } from 'react'
import apiClient from '../services/api'

type AdminClipRow = {
  clip: { id: string; name: string; status: string; createdDate: string }
  ownerUserId: string
  ownerEmail?: string
  creatorTier?: string
}

export function CreatorClips() {
  const [clips, setClips] = useState<AdminClipRow[]>([])
  const [search, setSearch] = useState('')
  const [tier, setTier] = useState('')
  const [loading, setLoading] = useState(true)

  const load = async () => {
    setLoading(true)
    try {
      const params = new URLSearchParams()
      if (search) params.set('search', search)
      if (tier) params.set('tier', tier)
      const { data } = await apiClient.get(`/admin/creator-clips?${params}`)
      setClips(data.clips || [])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Creator Clips</h1>
      <div className="flex gap-3 mb-4">
        <input
          className="border rounded-lg px-3 py-2 text-sm"
          placeholder="Search clip or owner…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select className="border rounded-lg px-3 py-2 text-sm" value={tier} onChange={(e) => setTier(e.target.value)}>
          <option value="">All tiers</option>
          <option value="creator_starter">Starter</option>
          <option value="creator_pro">Pro</option>
          <option value="creator_studio">Studio</option>
        </select>
        <button type="button" className="bg-primary-600 text-white px-4 py-2 rounded-lg text-sm" onClick={load}>
          Filter
        </button>
      </div>
      {loading ? (
        <p>Loading…</p>
      ) : (
        <table className="min-w-full divide-y divide-gray-200 bg-white rounded-lg shadow">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Clip</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Status</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Owner</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Tier</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Created</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {clips.map((row) => (
              <tr key={row.clip.id}>
                <td className="px-4 py-2 text-sm">{row.clip.name}</td>
                <td className="px-4 py-2 text-sm capitalize">{row.clip.status}</td>
                <td className="px-4 py-2 text-sm">{row.ownerEmail || row.ownerUserId}</td>
                <td className="px-4 py-2 text-sm">{row.creatorTier || '—'}</td>
                <td className="px-4 py-2 text-sm">{row.clip.createdDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
